import React from 'react';
import { withPrefix } from "gatsby";
import Section from '../Layout/Section/Section'
import PreviewCompatibleImage from '../Utils/PreviewCompatibleImage';
import InnerContainer from '../Layout/InnerContainer/InnerContainer';
import RenderStackedHeadline from  '../Utils/RenderStackedHeadline';

import './editorial-portrait.scss';

function renderBody(block, i) {
  const body = [];

  if (block.body != null) {
    body.push(
      <p key={i} className="body-copy">{block.body}</p>
    );
  }

  return body;
}
  
function renderBullets(block, key) {
  const listItems = [];
    
  if (block.bullets && block.bullets[0].bullet !== "") {
    block.bullets.map((item, i) => {
      return listItems.push(
        <li key={i} className="animate-on-scroll">{item.bullet}</li>
      )
    })
    
    return <ul className="body-copy">{listItems}</ul>;
  }
}

function renderCopy(block, i) {
  const copyHTML = [];

  if (block.headline != null) {
    copyHTML.push(
      <h3 key={i} className="headline animate-on-scroll">{block.headline.toLowerCase()}</h3>
    );
  }

  if (block.body) {
    block.body.map((line, i) => {
      copyHTML.push(
        <p key={i} className="body-copy">{line.line}</p>
      )
    })
  }
  
  return copyHTML;
}

function renderBlocks(blocks) {
  if(!blocks) {
    return null
  }
  const allBlocksHTML = [];
  
  blocks.forEach((block, i) => {
    const blockHTML = [];
    if (block.headline != null || (block.body && block.body[0].line != null) || (block.bullets && block.bullets[0].bullet !== "")) {
      blockHTML.push(
        <div key={i} className="block animate-on-scroll">
          {renderCopy(block, "copy")}
          {renderBullets(block, "bullets")}
        </div>
      )
    }

    allBlocksHTML.push(blockHTML);
  })

  return allBlocksHTML;
}

function renderImageOrVideo(image, video, leftRight) {
  if (image) {
    return <PreviewCompatibleImage customClass={`cover__image ${leftRight}`} imageInfo={image} alt="cover image" />
  } else if (video) {
    const videoPoster = video.poster ? getPosterFrameURL(video.poster) : '';
    const videoURL = video.src.includes("http") ? video.src : withPrefix('/' + video.src);
    return <video controls width="100%" poster={videoPoster}><source src={videoURL} type="video/mp4" /></video>
  }
}

function getPosterFrameURL(posterFrame) {
  return posterFrame.includes("http") ? posterFrame : withPrefix('/' + posterFrame);
}

const EditorialPortrait = ({image, copy, video}, leftRight="left" ) => {  
  if(!copy) {
    return null
  }

  return (
    <>
      <Section customClass="editorial-portrait">
        {copy ? RenderStackedHeadline(copy) : ''}
        <InnerContainer>
          {renderImageOrVideo(image, video, leftRight)}
          <div className="editorial-portrait__copy-blocks">
            {renderBlocks(copy.blocks)}
          </div>
        </InnerContainer>
      </Section>
    </>
  )
}

export default EditorialPortrait
